<!-- title -->
<app-modal-title [title]="'common.paymentImage'|translate" [isShowClose]="true" (isCloseModal)="onClose()"></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <div class="m-0">
    <div>

      <!--image-->
      <div *ngIf="image||(pdfUrl==null&&image==null)">
        <app-show-images class="tw-mt-1" imgHeight="170px" [src]="image"></app-show-images>
      </div>

      <!--pdf url-->
      <div *ngIf="pdfUrl">
        <app-pdf-reader class="tw-mt-1" [src]="pdfUrl"></app-pdf-reader>
      </div>

    </div>
  </div>
</div>
